import { Tab, TabList } from "@fluentui/react-components";
import React from "react";
import { HubConnection } from "@microsoft/signalr";
import { Breadcrumbs, BreadcrumbItem as Breadcrumb } from 's365-dashboard-v2-file-picker';
import { BreadcrumbItem } from '../../swagger-clients/s365-dashboard-v2-api-clients.service';
import { useNavigate } from "react-router-dom";
import SharedWithMeFilesTable, { SharedWithMeFilesTableType } from "./shared-with-me-files-table";
import { SharedWithMeFiltersTable } from "./shared-with-me-filters-table";
import { SharedWithMeDoETable } from "./shared-with-me-doe-table";
import { SharedWithMeMssTable } from "./shared-with-me-mss-table";

type SharedWithMePageProps = {
    hubConnection?: HubConnection
}
const emptyBreadcrumbs = [{ name: "Shared with me" } as BreadcrumbItem];

export const SharedWithMePage: React.FC<SharedWithMePageProps> = (props) => {

    const [breadcrumbs, setBreadcrumbs] = React.useState<BreadcrumbItem[]>(emptyBreadcrumbs);
    const [selectedTab, setSelectedTab] = React.useState<string>("files");
    const shareFilesTableRef = React.createRef<SharedWithMeFilesTableType>();
    const navigate = useNavigate();

    return <div className='page-wrapper'>
        <div className='files-wrapper'>
            <div className='files-wrapper__breadcrumbs-wrapper'>
                <Breadcrumbs>
                    {breadcrumbs.map((test: BreadcrumbItem) => {
                        return <Breadcrumb
                            key={`breadcrumb-${test.uniqueIdentifier ?? "dashboard"}`}
                            onClick={() => {  shareFilesTableRef.current?.onNavigateTo(test.uniqueIdentifier); }}>{test.name}</Breadcrumb>
                    })}
                </Breadcrumbs>
            </div>


            <TabList selectedValue={selectedTab} onTabSelect={(ev, data) => {
                navigate(`/files/shared-with-me`, { replace: true });
                setSelectedTab(data.value as string);
            }}>
                <Tab key="files" value="files" >Files</Tab>
                {/* <Tab key="filters" value="filters">Filters</Tab>
                <Tab key={"doe-experiments"} value="doe-experiments">Design of Experiments (DoE)</Tab>
                <Tab key="mss-studies" value="mss-studies">Multivariate Sensitivity Studies (MSS)</Tab>
                <Tab key="optimum-tests" value="optimum-tests">Optimum Tests (OT)</Tab> */}
            </TabList>
            <div className="tab-content">
                {selectedTab == "files" &&
                    <SharedWithMeFilesTable
                        ref={shareFilesTableRef}
                        hubConnection={props.hubConnection}
                        onBreadcrumbsChange={(items) => {
                            setBreadcrumbs([...emptyBreadcrumbs, ...items]);
                        }} />}

                {/* {selectedTab == "filters" && <SharedWithMeFiltersTable hubConnection={props.hubConnection} />}
                {selectedTab == "doe-experiments" && <SharedWithMeDoETable hubConnection={props.hubConnection} />}
                {selectedTab == "mss-studies" && <SharedWithMeMssTable isOptimumTest={false} hubConnection={props.hubConnection} />}
                {selectedTab == "optimum-tests" && <SharedWithMeMssTable isOptimumTest={true} hubConnection={props.hubConnection} />} */}

            </div>
        </div>
    </div>
}
